import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'

import Button from '@/components/Button'
import Icon from '@/components/Icon'
import { ArticleSelect } from '@/components/features/support/ArticleSelect'
import Form from '@/components/form/Form'
import FormField from '@/components/form/FormField'

const SupportSearchBar = () => {
  return (
    <Form onSubmit={(event) => event.preventDefault()}>
      <FormField>
        <div
          className={clsx(
            'relative flex items-center rounded-xl border-[0.5px] border-slate-300 bg-white',
            'py-[5px] pl-3 pr-1.5 shadow-md tablet:pl-4 tablet:pr-2 desktop:py-[7px] desktop:pr-2.5'
          )}
        >
          <ArticleSelect
            className="!border-none bg-transparent focus:bg-transparent"
            buttonClassName="max-desktop:pl-4"
            hasOutline={false}
          />
          <Button
            className="ml-2 !p-[9px] tablet:!px-5"
            type="submit"
            variant="primary"
          >
            <Icon className="h-6 w-6 flex-none" name="search-24" />
            <span className="hidden tablet:ml-6 tablet:block desktop:ml-3">
              <FormattedMessage
                {...{
                  id: 'chat.search',
                  defaultMessage: 'Поиск'
                }}
              />
            </span>
          </Button>
        </div>
      </FormField>
    </Form>
  )
}

export default SupportSearchBar
